<div class="row search-result-count mx-0"
    *ngIf="dataLoaded && !taxonomyCheckbox"
    id="resultCount">
    <!-- Show the count for the search results found ----------->
    <div class="w-100 my-2 d-flex align-items-center pl-4" 
        role="alert" 
        aria-live="polite">
        <p class="font-bold mb-0 mr-1">
            
            {{totalfetchedResult}} Result(s) out of {{pageRangeData}}
        </p>
    </div>
</div>
<div class="py-2 px-3 border-bottom align-items-center justify-content-start mb-2"
    *ngIf="dataLoaded && taxonomyCheckbox">
    <div [ngStyle]="{'display':selectedNodeIds 
            && selectedNodeIds.length>0 ? 'block' : 'none' }">
            <app-select-association
                #selectAssociation
                (removeOptions)="removeCopiedOptions($event);"
                [viewLocation]="'searchList'"
                (associationsObj)="updateAssociationsObj($event);"
                (settingsModalOpen)="selectOptions($event);"
                [optionsToCopySaved]="optionsToCopySaved"
                [isCopy]="isCopy"
                [isCopyAssociation]="isCopyAssociation"
                [displayText]="displayText"
                [displayOption]="displayOption"
                [currentTab]="currentTab">
            </app-select-association>
    </div>
    <div *ngIf="!selectedNodeIds || selectedNodeIds.length===0"
        role="alert" aria-live="polite">
        <p class="pr-3 mb-0 d-inline-block">{{totalfetchedResult}} Result(s) out of {{pageRangeData}} </p>
        <button 
            class="btn btn-clear text-underline btn-sm"
            type="button"
            (click)="resetSearch();">Reset Search
        </button>
    </div>
</div>

<div class="d-flex pl-3" *ngIf="searchResult && searchResult.length >0">
    <div class="w-100 panel-left">
        <div *ngFor="let srchItm of searchResult; let i = index" class="my-3">
            <ng-container *ngIf="srchItm['_index'] !== 'cfprojects'">
                <div class="d-flex w-100">
                    <div class="col-auto pr-0" *ngIf="taxonomyCheckbox">
                        <div class="custom-control custom-checkbox mt-2">
                            <input 
                                type="checkbox" 
                                class="custom-control-input"
                                id="{{ 'chk' + i }}"
                                [disabled]="srchItm['_index'] === 'cfdocument'
                                && disableDocument? true:false"
                                (click)="srchItm.isChecked = !srchItm.isChecked;
                                updatedSelection(srchItm.unique_node_id,
                                                srchItm.isChecked);">
                                <label 
                                    class="custom-control-label"
                                    for="{{ 'chk' + i }}">
                                <span class="sr-only">
                                    Select {{srchItm._source.title}}
                                </span>
                            </label>
                        </div>
                    </div>
                    <div class="d-flex w-100 justify-content-between
                                panel-highlight mr-3 py-2">
                        <div class="col-10 pl-1 pr-0 d-flex align-items-center">
                            <button
                                type="button"
                                class="btn btn-clear text-left py-0 searched-node text-wrap-button"
                                *ngIf="srchItm['_index'] === 'cfdocument'"
                                (click)="onTreeNodeSelected(srchItm);
                                            clicked = srchItm"
                                id="{{ 'a-tag' + i }}">
                                <span [mathJax]="srchItm._source.title
                                                ? srchItm._source.title : ''">
                                </span>
                            </button>
                            <button 
                                type="button"
                                class="btn btn-clear text-left text-wrap-button"
                                *ngIf="srchItm['_index'] === 'cfitems'"
                                (click)="onTreeNodeSelected(srchItm);
                                        clicked = srchItm"
                                id="{{ 'a-tag' + i }}">
                                <ng-container 
                                    *ngIf="srchItm._source.humanCodingScheme">
                                    <span
                                        [mathJax]="srchItm._source.humanCodingScheme
                                            ? srchItm._source.humanCodingScheme + ' '
                                            :''">
                                    </span>
                                </ng-container>
                                <ng-container
                                    *ngIf="srchItm._source.fullStatement">
                                    <span
                                        [mathJax]="srchItm._source.fullStatement
                                                ? srchItm._source.fullStatement
                                                : ''">
                                    </span>
                                </ng-container>
                            </button>
                            <button 
                                type="button" 
                                class="btn btn-clear text-left text-wrap-button"
                                *ngIf="srchItm['_index'] === 'cfassociations'"
                                (click)="onTreeNodeSelected(srchItm);
                                        clicked = srchItm" 
                                id="{{ 'a-tag' + i }}">
                                <ng-container 
                                    *ngIf="srchItm._source.originNodeURI.title">
                                    <span
                                        [mathJax]="srchItm._source.originNodeURI.title
                                            ? srchItm._source.originNodeURI.title
                                            : ''">
                                    </span>
                                </ng-container>
                            </button>
                        </div>
                        <div class="col-2 pl-0 text-right d-flex
                                    justify-content-end align-items-center">
                            <p 
                                *ngIf="srchItm['_index'] === 'cfitems'"
                                class="mb-0 mr-2 grade text-truncate">
                                {{srchItm._source.CFItemTypeURI.title}}
                            </p>

                            <p
                                *ngIf="srchItm['_index'] === 'cfdocument'"
                                class="mb-0 mr-2 grade text-truncate">
                                {{srchItm._source.nodeType}}
                            </p>

                            <button
                                class="btn btn-clear p-0 tooltip left mt-1"
                                data-tooltip="View taxonomy details"
                                aria-label="Taxonomy Details [Opens in a new window]"
                                (click)="navigate(srchItm)">
                                <span class="material-icons-outlined font-4x"
                                aria-hidden="true">
                                    open_in_new
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
                <ng-container>
                    <div *ngIf="(srchItm.parent_hierarchy
                                && srchItm.parent_hierarchy.length
                                && srchItm.parent_hierarchy.length > 0)"
                            id="{{ 'accordionBody' + i }}">
                        <nav aria-label="breadcrumb" class="mt-3">
                            <ol class="breadcrumb mb-0 py-0 px-5 d-flex
                                        align-items-center">
                                <li 
                                    class="d-flex align-items-center col-auto p-0"
                                    *ngFor="let parent of srchItm.parent_hierarchy | reverse;
                                        let i = index">
                                        <span
                                            *ngIf="!parent.document_id
                                                && i>=srchItm.parent_hierarchy.length-2
                                                && i<srchItm.parent_hierarchy.length"
                                            class="material-icons-outlined spliter"
                                            aria-hidden="true">
                                            navigate_next
                                        </span>
                                        <span
                                            *ngIf="parent.document_id
                                                && srchItm.parent_hierarchy.length > 1"
                                            class="material-icons-outlined font-2x"
                                            title="{{parent.title}}{{showTitles(srchItm.parent_hierarchy)}}">
                                            more_horiz
                                        </span>
                                        <span
                                            class="d-flex col-auto max-width p-0">
                                            <button 
                                                *ngIf="parent.document_id
                                                    && srchItm.parent_hierarchy.length === 1"
                                                type="button"
                                                role="link"
                                                class="btn btn-clear text-truncate
                                                    max-width font-1x px-0 text-wrap-button"
                                                (click)="onTreeNodeSelected(parent, srchItm.parent_hierarchy)"
                                                title="{{parent.human_coding_scheme}}
                                                    {{parent.full_statement}}">
                                                <span aria-hidden="true">
                                                    {{parent.title}}
                                                </span>
                                            </button>
                                        </span>
                                        <span
                                            class="d-flex col-auto max-width p-0">
                                            <button 
                                                *ngIf="!parent.document_id
                                                    && i>=srchItm.parent_hierarchy.length-2
                                                    && i<srchItm.parent_hierarchy.length"
                                                type="button"
                                                role="link"
                                                class="btn btn-clear text-truncate max-width font-1x px-0 text-wrap-button"
                                                (click)="onTreeNodeSelected(parent, srchItm.parent_hierarchy)"
                                                title="{{parent.human_coding_scheme}} {{parent.full_statement}}">
                                                <span aria-hidden="true">
                                                    {{parent.human_coding_scheme}} {{parent.full_statement}}
                                                </span>
                                            </button>
                                        </span>
                                </li>
                            </ol>
                        </nav>
                    </div>
                </ng-container>
            </ng-container>
        </div>  
            <button
                *ngIf="(searchResult?.length >= pagination
                    && searchResult?.length < totalSearchResults)"
                id="loadMoreButton"
                class="btn btn-showMore align-items-center px-1
                        position-relative border-0"
                (click)="loadMoreList()">
                <svg xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    width="20"
                    aria-hidden="true"
                    class="icon mr-2 position-relative">
                    <path
                        d="M4.958 11.625Q4.292 11.625 3.812 11.146Q3.333 10.667 3.333 10Q3.333 9.333 3.812 8.854Q4.292 8.375 4.958 8.375Q5.625 8.375 6.104 8.854Q6.583 9.333 6.583 10Q6.583 10.667 6.104 11.146Q5.625 11.625 4.958 11.625ZM10 11.625Q9.333 11.625 8.854 11.146Q8.375 10.667 8.375 10Q8.375 9.333 8.854 8.854Q9.333 8.375 10 8.375Q10.667 8.375 11.146 8.854Q11.625 9.333 11.625 10Q11.625 10.667 11.146 11.146Q10.667 11.625 10 11.625ZM15.042 11.625Q14.375 11.625 13.896 11.146Q13.417 10.667 13.417 10Q13.417 9.333 13.896 8.854Q14.375 8.375 15.042 8.375Q15.708 8.375 16.188 8.854Q16.667 9.333 16.667 10Q16.667 10.667 16.188 11.146Q15.708 11.625 15.042 11.625Z" />
                </svg>
                <span class="sr-only">
                    {{pagination}} nodes
                </span>
                <span class="info position-relative">
                    Show more
                </span>
            </button>
            <button
                *ngIf="!firstPage && totalfetchedResult > pagination"
                id="loadPrevButton"
                class="btn btn-showMore align-items-center px-1
                        position-relative border-0"
                (click)="loadPrevList()">
                <svg xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    width="20"
                    aria-hidden="true"
                    class="icon mr-2 position-relative">
                    <path
                        d="M4.958 11.625Q4.292 11.625 3.812 11.146Q3.333 10.667 3.333 10Q3.333 9.333 3.812 8.854Q4.292 8.375 4.958 8.375Q5.625 8.375 6.104 8.854Q6.583 9.333 6.583 10Q6.583 10.667 6.104 11.146Q5.625 11.625 4.958 11.625ZM10 11.625Q9.333 11.625 8.854 11.146Q8.375 10.667 8.375 10Q8.375 9.333 8.854 8.854Q9.333 8.375 10 8.375Q10.667 8.375 11.146 8.854Q11.625 9.333 11.625 10Q11.625 10.667 11.146 11.146Q10.667 11.625 10 11.625ZM15.042 11.625Q14.375 11.625 13.896 11.146Q13.417 10.667 13.417 10Q13.417 9.333 13.896 8.854Q14.375 8.375 15.042 8.375Q15.708 8.375 16.188 8.854Q16.667 9.333 16.667 10Q16.667 10.667 16.188 11.146Q15.708 11.625 15.042 11.625Z" />
                </svg>
                <span class="sr-only">
                    {{pagination}} nodes
                </span>
                <span class="info position-relative">
                    Show previous
                </span>
            </button>
    </div>
</div>

<div 
    class="sidenav sidenav-offcanvas node-details-overlay position-fixed"
    id="mySidenavES"
    aria-label="Comment">
    <div class="node-details-overlay-container">
        <app-preloader 
            [hidden]="!showAdditionalDataLoader"
            [loaderText]="alertMsgs?.loading_metadata"
            class="w-100 position-absolute preloader-backdrop"
            style="width:100%">
        </app-preloader>
        <div [hidden]="showAdditionalDataLoader">
            <header class="sidenav__header d-flex justify-content-between
                            align-items-center">
                <div class="col-10 pr-0">
                    <h2 class="label mb-0 font-bold">Taxonomy details</h2>
                    <!-- <p class="mb-0 text-truncate"
                        [mathJax]="currentItem.taxonomyTitle">
                    </p> -->
                </div>
                <div class="col-auto">
                    <button
                        type="button"
                        class="btn btn-icon"
                        id="close-note"
                        (click)="closeNav()"
                        aria-label="Close">
                        <em class="material-icons-outlined font-4x"
                            aria-hidden="true">
                            close
                        </em>
                    </button>
                </div>
            </header>
            <div class="col-12 project-authoring pt-2 px-4">
                <app-tree-node-details 
                    [showTaxonomyName] = "showTaxonomyName"
                    [nodeData]="nodeData"
                    (treeNodeDataFetched)="treeNodeDataFetched($event)">
                </app-tree-node-details>
            </div>
        </div>
    </div>
</div>